module.exports = ".panel > button {\n  margin: 0 0 15px 15px; }\n\n.panel .panel {\n  margin-top: 15px; }\n\n.panel .panel button {\n    margin-top: 15px; }\n\n.checkbox-error {\n  margin-top: 5px;\n  color: #d9534f; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal-edit/organisation-form/organisation-form.component.scss
// module id = ./src/app/modal-edit/organisation-form/organisation-form.component.scss
// module chunks = main